('use strict');

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JSX Modules
import CustomUniversalSelect from '../_utils/custom-universal-select';

// -----------------------------------------------------------
//  Sort
// -----------------------------------------------------------

const Sort = ({ value, onChange, options }) => {
  const ariaLabel =
    options.find((option) => option.value === value)?.label || options[0].label;

  return (
    <form className="form-inline sort">
      <div className="form-group">
        <label htmlFor="sort-select" aria-label={`Sort by ${ariaLabel}`}>
          Sort by&nbsp;&nbsp;|
        </label>
        <CustomUniversalSelect
          ariaLabel="Sort by"
          options={options}
          value={value}
          onChange={onChange}
        />
      </div>
    </form>
  );
};

Sort.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default Sort;
